import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
  selector: 'app-loader',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="loader"><mat-spinner></mat-spinner></div>
  `
})
export class LoaderComponent {}
